export default "/images/792699d4e478fbd03d3edbd205567e58.avif";